import { CONSTANTS } from '@sohohouse/platform-resources'
import { platformAction } from '~/helpers/store'
import {
  RESULTS_PER_PAGE,
  defaultFilters,
  previousFilters,
  filterStates,
  previousFilterStates
} from '../constants'

const { FAILED, CANCELLED } = CONSTANTS.EVENT_BOOKING_STATES

export default {

  async fetchEventBookings ({ commit }) {
    await platformAction({
      client: this.$api.events.bookings,
      method: 'getAll',
      params: {
        filter: {
          ...defaultFilters,
          state: filterStates
        },
        sort: 'event.starts_at',
        perPage: 3
      },
      include: ['event', 'event.resource'],
      commit,
      logError: this.$logError
    })
  },
  async fetchPreviousBookings ({ commit, state }, opts = { more: false }) {
    const prevFilters = Object.assign({}, previousFilters)
    const type = 'previous'
    const cached = state.cached[type]
    let page = 1

    if (cached && opts.more) {
      page = cached.meta.page + 1

      if (page > cached.meta.totalPages) {
        return
      }
    }

    commit('fetchingByType', type)

    const bookings = await platformAction({
      client: this.$api.events.bookings,
      method: 'getAll',
      simple: false,
      params: {
        filter: {
          ...prevFilters,
          state: previousFilterStates
        },
        page,
        perPage: 6
      },
      include: ['event', 'event.resource', 'venue'],
      commit,
      logError: this.$logError
    })

    commit('fetchedByType', type)
    commit('saveSearch', { type, bookings })
  },
  async createEventBooking ({ commit, dispatch, getters }, payload) {
    const rawBooking = await platformAction({
      client: this.$api.events.bookings,
      method: 'create',
      params: payload,
      commit: (mutationType, mutationPayload) => {
        if (mutationType !== 'fetched') {
          commit(mutationType, mutationPayload)
        }
      },
      logError: this.$logError
    })

    if (rawBooking) {
      const booking = getters.bookingById(rawBooking.id)

      if (booking.unprocessed) {
        const event = await dispatch('events/events/pollEvent', booking.relationships.event.id, { root: true })
        if (event && [FAILED, CANCELLED].includes(event.booking.state)) {
          const { id, type } = booking
          commit('clearSearchById', { id, type })
        }
      } else {
        await dispatch('events/events/fetchEvent', booking.relationships.event.id, { root: true })
      }
    }

    commit('fetched')
  },
  async updateEventBooking ({ commit, dispatch, getters }, payload) {
    const rawBooking = await platformAction({
      client: this.$api.events.bookings,
      method: 'update',
      params: payload,
      commit: (mutationType, mutationPayload) => {
        if (mutationType !== 'fetched') {
          commit(mutationType, mutationPayload)
        }
      },
      logError: this.$logError
    })

    if (rawBooking) {
      const booking = getters.bookingById(rawBooking.id)

      if (booking.unprocessed) {
        await dispatch('events/events/pollEvent', booking.relationships.event.id, { root: true })
      } else {
        await dispatch('events/events/fetchEvent', booking.relationships.event.id, { root: true })
      }
    }

    commit('fetched')
  },
  async deleteEventBooking ({ commit }, { id, type }) {
    await platformAction({
      client: this.$api.events.bookings,
      method: 'delete',
      params: id,
      commit,
      logError: this.$logError
    })
    commit('clearSearchById', { id, type })
  },
  async fetchEventBookingsByType ({ commit, state }, { type, more = false }) {
    const cached = state.cached[type]
    let page = 1

    if (cached && more) {
      page = cached.meta.page + 1
      if (page > cached.meta.totalPages) {
        return
      }
    }

    commit('fetchingByType', type)

    const bookings = await platformAction({
      client: this.$api.events.bookings,
      method: 'getAll',
      commit,
      logError: this.$logError,
      simple: false,
      params: {
        filter: {
          ...defaultFilters,
          state: filterStates,
          eventType: type
        },
        page,
        perPage: RESULTS_PER_PAGE,
        sort: 'event.starts_at'
      },
      include: ['event', 'event.resource']
    })

    commit('fetchedByType', type)
    commit('saveSearch', { type, bookings })
  },
  async updateRelationshipEventBooking ({ commit }, payload) {
    await platformAction({
      client: this.$api.events.bookings,
      method: 'changeBookingEvent',
      params: payload,
      commit,
      logError: this.$logError
    })
  }
}
